import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoShieldFlash24 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M18.6668 7.38639V11.9269C18.6668 16.0357 15.3895 17.8034 12.0846 19.586L12.0002 19.6316L11.9157 19.586C8.61078 17.8034 5.3335 16.0357 5.3335 11.9269V7.38639C5.3335 7.03056 5.55943 6.71399 5.89593 6.59832L11.7292 4.59311C11.9048 4.53276 12.0955 4.53276 12.2711 4.59311L18.1044 6.59832C18.4409 6.71399 18.6668 7.03056 18.6668 7.38639Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M12.3877 8.25L10.5566 11.2691C10.5566 11.3761 10.6434 11.4628 10.7503 11.4628H13.7139C13.8687 11.4628 13.9609 11.6352 13.8751 11.7639L11.3751 15.75" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoShieldFlash24;